<br>
<section>
    <div class="container">
        <app-text-img titulo={{primerTitulo}} parrafo={{primerParrafo}}
            imagen='../../../../assets/img/declaraciones/impuestos-dinero.jpg'>
        </app-text-img>
        <br>
        <app-img-text titulo={{segundoTitulo}} parrafo={{segundoParrafo}}
            imagen='../../../../assets/img/declaraciones/calculadora-impuestos.jpg'>
        </app-img-text>
        <br>
        <app-text-img titulo={{tercerTitulo}} parrafo={{tercerParrafo}}
            imagen='../../../../assets/img/declaraciones/monedas-retonos.jpg'>
        </app-text-img>
    </div>
</section>
<br>